import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { NavigationService } from '../../shared/navigation/navigation.service';

@Component({
  selector: 'wl-dashboard-revenue',
  templateUrl: 'revenue.component.html',
  encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class DashboardRevenueComponent implements OnInit {
  private _navigationService: NavigationService;

  public constructor(navigationService: NavigationService) {
    this._navigationService = navigationService;
  }

  ngOnInit() {}

  public openARSummaryReport() {
    this._navigationService.navigateToARSummaryReport();
  }

  public openRevenueByTypeReport() {
    this._navigationService.navigateToRevenueByTypeReport();
  }

  public openPaymentsAppliedReport() {
    this._navigationService.navigateToPaymentsAppliedReport();
  }
}
